// extracted by mini-css-extract-plugin
export default {"container":"Oj2p2cmwOnKc7t8WDI88","paymentInfo":"vER9czZukiNacQcvt_cw"};